import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { UserTrackableLinkReportDetailSummary } from "@/components/assist/user-trackable-links/report/user-trackable-link-report-detail-summary";
import { UserTrackableLinkReportDetailList } from "@/components/assist/user-trackable-links/report/user-trackable-link-report-detail-list";

import type { JSX } from "react";

const UserTrackableLinkReportPageQuery = graphql(`
  query UserTrackableLinkReportPageQuery($userTrackableLinkId: Int!) {
    userTrackableLink: usuariosLinksRastreamentos_by_pk(
      codUsuarioLinkRastreamento: $userTrackableLinkId
    ) {
      codLinkRastreamento
      dataCadastro
      ...UserTrackableLinkReportDetailSummaryFragment
    }
  }
`);

const UserTrackableLinkReport = (): JSX.Element => {
  const { userTrackableLinkId } = Route.useParams();
  const queryResult = useGraphQL(UserTrackableLinkReportPageQuery, {
    userTrackableLinkId: parseInt(userTrackableLinkId),
  });
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Relatório de desempenho" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          <div className="flex flex-col gap-4">
            {data?.userTrackableLink ? (
              <>
                <UserTrackableLinkReportDetailSummary
                  userTrackableLink={data.userTrackableLink}
                />
                <div className="flex flex-col gap-2">
                  <UserTrackableLinkReportDetailList
                    codLinkRastreamento={data.userTrackableLink.codLinkRastreamento}
                    dataCadastro={data.userTrackableLink.dataCadastro}
                  />
                </div>
              </>
            ) : null}
          </div>
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/assist/user-trackable-links/$userTrackableLinkId/report/",
)({
  component: UserTrackableLinkReport,
});
